<template>
  <div v-if="needRefresh" 
       class="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white shadow-lg border-t">
    <div class="max-w-4xl mx-auto flex items-center justify-between">
      <p class="text-gray-700">New version available</p>
      <div class="flex gap-2">
        <button 
          @click="refreshApp" 
          class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
          Update
        </button>
        <button 
          @click="close" 
          class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { SwEventBus } from '../registerServiceWorker';

export default {
  name: 'PWAUpdateNotification',
  setup() {
    const needRefresh = ref(false);
    let registration = null;

    const refreshApp = () => {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    };

    const close = () => {
      needRefresh.value = false;
    };

    onMounted(() => {
      SwEventBus.addEventListener('sw-ready', () => {
        console.log('App is being served from cache by a service worker.');
      });
      
      SwEventBus.addEventListener('sw-registered', (event) => {
        registration = event.detail;
        console.log('Service worker has been registered.');
      });
      
      SwEventBus.addEventListener('sw-cached', () => {
        console.log('Content has been cached for offline use.');
      });
      
      SwEventBus.addEventListener('sw-updatefound', () => {
        console.log('New content is downloading.');
      });
      
      SwEventBus.addEventListener('sw-updated', (event) => {
        registration = event.detail;
        needRefresh.value = true;
        console.log('New content is available; please refresh.');
      });
      
      SwEventBus.addEventListener('sw-offline', () => {
        console.log('No internet connection found. App is running in offline mode.');
      });
      
      SwEventBus.addEventListener('sw-error', (event) => {
        console.error('Error during service worker registration:', event.detail);
      });
    });

    return {
      needRefresh,
      refreshApp,
      close
    };
  }
};
</script>
